/** Every Reporting panel the canvas can open, in rail order, by the short id the URL carries. */
export const PANELS = [
  { id: "growth", title: "Rate of growth", group: "growth" },
  { id: "overview", title: "Overview", group: "social" },
  { id: "followers", title: "Followers", group: "social" },
  { id: "trends", title: "Performance Trends", group: "social" },
  { id: "booking", title: "Booking Intent", group: "social" },
  { id: "content", title: "Content Insights", group: "social" },
  { id: "profile", title: "Business Profile", group: "google" },
  { id: "website", title: "Website", group: "google" },
  { id: "metaads", title: "Ad performance", group: "paid" },
  { id: "googleads", title: "Google Ads", group: "paid" },
  { id: "facebook", title: "Facebook", group: "platforms" },
  { id: "instagram", title: "Instagram", group: "platforms" },
  { id: "tiktok", title: "TikTok", group: "platforms" },
] as const;

export type PanelId = (typeof PANELS)[number]["id"];
export type PanelGroup = (typeof PANELS)[number]["group"];

export const PANEL_GROUPS: ReadonlyArray<{ id: PanelGroup; label: string | null }> = [
  { id: "growth", label: null },
  { id: "social", label: "Social" },
  { id: "google", label: "Google" },
  { id: "paid", label: "Paid" },
  { id: "platforms", label: "By platform" },
];

/** What the canvas opens on with no layout in the URL. */
export const DEFAULT_PANEL: PanelId = "growth";

export const isPanelId = (value: string): value is PanelId => PANELS.some((p) => p.id === value);

export const panelTitle = (id: PanelId): string => PANELS.find((p) => p.id === id)?.title ?? id;
